import { Dialog } from "@material-ui/core";
import React, { Component } from "react";
import "./VideoInfoDialog.scss";
import i18n from "@/i18n";
class VideoInfoDialog extends Component {
  render() {
    const { open, onClose, videoInfo } = this.props;
    const { name, videoName, fonts, music } = videoInfo;
    return (
      <Dialog
        open={open}
        className="video-info-dialog-container"
        onClose={onClose}
      >
        <div className="dialog-wrap">
          <div className="dialog-header">
            <div />
            <h6>{i18n.t("video.info.title")}</h6>
            <div className="close-btn" onClick={onClose}>
              <img src="https://front.videomonster.com/images-7cuytg20/web/videoDialog/close_icon.svg" alt="" />
            </div>
          </div>
          <div className="dialog-content">
            <div className="info-list">
              <div className="row">
                <span>{i18n.t("video.info.col.title")}</span>
                <span>{videoName}</span>
              </div>
              <div className="row">
                <span>{i18n.t("video.info.col.template")}</span>
                <span>{name}</span>
              </div>
              {fonts.length ? (
                <div className="row">
                  <span>{i18n.t("video.info.col.font")}</span>
                  <span>{fonts.join(", ")}</span>
                </div>
              ) : <></>}
              {music && (
                <div className="row">
                  <span>{i18n.t("video.info.col.music")}</span>
                  <span>{music}</span>
                </div>
              )}
            </div>
            <button className="dialog-btn" onClick={onClose}>
              {i18n.t("global.confirm")}
            </button>
          </div>
        </div>
      </Dialog>
    );
  }
}
export default VideoInfoDialog;
